import { EDIT_TAG_V2 } from "redux/reducers/tags/tagsReducer";
import { ADD_NEW_TAG_V2 } from "redux/reducers/tags/tagsReducer";
import { SET_TAGS_V2 } from "redux/reducers/tags/tagsReducer";
import { LOAD_TAGS_V2 } from "redux/reducers/tags/tagsReducer";
import { api_put } from "services/api";
import { api_post } from "services/api";
import { PROYECT } from "services/api";
import { api_get } from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";

export const getTagsV2 = (token) => {

  const auth = { headers: { authorization: `${token}` } };
  const urlTags = `${process.env.REACT_APP_URL}${PROYECT}/tags`;
  return async (dispatch) => {
    dispatch({type: LOAD_TAGS_V2})
    await api_get(urlTags, auth).then(resp => {
      dispatch({
        type: SET_TAGS_V2,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err.message || err || 'error'))
    })
  }
}



export const addNewTagV2 = (form, action) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/tags`;  
  return async (dispatch) => {
    dispatch(startRequestComp("loadingTags"))
    await api_post(url, form).then(resp => {
      dispatch({
        type: ADD_NEW_TAG_V2,
        payload: resp
      })
      action && action()
      dispatch(stopRequestComp("loadingTags"))
      dispatch(setSnackbar("Etiqueda Creada", "success"))
    }).catch(err => {
      dispatch(stopRequestComp("loadingTags"))
      dispatch(setSnackbar(err.message || err || 'error'))
    })
  }
}

export const editTagsV2 = (id, form, action) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/tags/${id}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingTags"))
    await api_put(url, form).then(resp => {
      dispatch({
        type: EDIT_TAG_V2,
        payload: resp
      })
      action && action()
      dispatch(stopRequestComp("loadingTags"))
      dispatch(setSnackbar("Etiqueda Editada", "success"))
    }).catch(err => {
      dispatch(stopRequestComp("loadingTags"))
      dispatch(setSnackbar(err.message || err || 'error'))
    })
  }
}